export const passwordRegex: RegExp =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[.:;?!*+%\-<>@[\]{}()/\\_{}$#])[A-Za-z\d.:;?!*+%\-<>@[\]{}()/\\_{}$#]{8,16}$/g
export const numericRegex: RegExp = /^\d+$/;
export const nameRegex: RegExp = /[^A-Za-z0-9-]/g;
export const onlyNumericRegex: RegExp = /^\d+$/g;
export const withoutCommas = /[,]/g;
export const uuidRegex: RegExp = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/gi;
